import React, { useState } from 'react';
import { CheckCircle, Clock, Upload, FileText, Database, Loader, AlertCircle, Brain, Layers, FileOutput, ChevronDown, ChevronUp } from 'lucide-react';
import './ProcessingStatus.css';

const ProcessingStatus = ({ documents }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const getStatusIcon = (status) => {
    switch (status) {
      case 'uploading':
        return <Upload size={16} />;
      case 'uploaded':
        return <CheckCircle size={16} />;
      case 'processing':
        return <Loader size={16} className="spinning" />;
      case 'categorizing':
        return <Layers size={16} className="spinning" />;
      case 'vectorizing':
        return <Database size={16} className="spinning" />;
      case 'extracting':
        return <Brain size={16} className="spinning" />;
      case 'generating':
        return <FileOutput size={16} className="spinning" />;
      case 'uploading_outbound':
        return <Upload size={16} className="spinning" />;
      case 'completed':
        return <CheckCircle size={16} />;
      case 'error':
        return <AlertCircle size={16} />;
      default:
        return <Clock size={16} />;
    }
  };

  const getStatusLabel = (status, stage) => {
    if (stage) return stage;
    
    switch (status) {
      case 'uploading':
        return 'Uploading to Azure';
      case 'uploaded':
        return 'Upload Complete';
      case 'processing':
        return 'Processing PDF';
      case 'categorizing':
        return 'Categorizing Content';
      case 'vectorizing':
        return 'Creating Vector Embeddings';
      case 'extracting':
        return 'AI Data Extraction';
      case 'generating':
        return 'Generating Results';
      case 'uploading_outbound':
        return 'Uploading to Outbound';
      case 'completed':
        return 'Processing Complete';
      case 'error':
        return 'Processing Failed';
      default:
        return 'Pending';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return '#10b981';
      case 'error':
        return '#ef4444';
      case 'uploading':
      case 'uploaded':
      case 'processing':
      case 'categorizing':
      case 'vectorizing':
      case 'extracting':
      case 'generating':
      case 'uploading_outbound':
        return '#3b82f6';
      default:
        return '#6b7280';
    }
  };

  // const formatFileSize = (size_mb) => {
  //   if (!size_mb) return '';
  //   return `${size_mb.toFixed(2)} MB`;
  // };

  // const formatUploadTime = (timestamp) => {
  //   if (!timestamp) return '';
  //   return new Date(timestamp).toLocaleString();
  // };

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="processing-status">
      <div className="status-header" onClick={toggleCollapse} style={{ cursor: 'pointer' }}>
        <div className="header-title">
          <FileText size={24} />
          <h3>Document Processing Status</h3>
        </div>
        {isCollapsed ? <ChevronDown size={20} /> : <ChevronUp size={20} />}
      </div>

      {!isCollapsed && (
        <div className="status-content">
          {documents.map((doc) => (
            <div key={doc.id} className={`status-item ${doc.status}`}>
              <div className="status-info">
                <div className="doc-details">
                  <span className="doc-name">{doc.name}</span>
                  <span className="doc-category">{doc.category}</span>
                </div>
                
                <div className="status-indicator">
                  <div 
                    className="status-icon"
                    style={{ color: getStatusColor(doc.status) }}
                  >
                    {getStatusIcon(doc.status)}
                  </div>
                  <span 
                    className="status-text"
                    style={{ color: getStatusColor(doc.status) }}
                  >
                    {getStatusLabel(doc.status, doc.stage)}
                  </span>
                </div>
              </div>

              <div className="progress-container">
                <div className="progress-bar">
                  <div 
                    className="progress-fill"
                    style={{ 
                      width: `${doc.progress}%`,
                      backgroundColor: getStatusColor(doc.status)
                    }}
                  />
                </div>
                <span className="progress-text">{doc.progress}%</span>
              </div>

              {doc.message && (
                <div className="status-message">
                  <span>{doc.message}</span>
                </div>
              )}

              {doc.results && (
                <div className="completion-info">
                  {/* <div className="ai-results">
                    <h4>Results</h4>
                    <div className="results-grid">
                      <div className="result-item">
                        <span className="result-label">Output File:</span>
                        <span className="result-value">{doc.results.json_file}</span>
                      </div>
                    </div>
                  </div> */}
                  
                  <div className="success-message">
                    <CheckCircle size={16} />
                    <span>Document processed successfully and results uploaded to Azure outbound folder</span>
                  </div>
                </div>
              )}

              {doc.status === 'error' && (
                <div className="error-details">
                  <AlertCircle size={16} />
                  <span>{doc.error || 'An error occurred during processing'}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProcessingStatus; 